import {apiClient} from '@/api/apiClient';
import {ANTIFORGERY_TOKEN_HEADER, readAntiforgeryToken} from '@/api/antiforgery';
import type {Announcement} from './types';

/**
 * Returns the mailbox as it stands after the dismissal — which doubles as a refresh. The layout
 * only re-renders on a full page load, so a user working through sub-page tabs would otherwise
 * never see an announcement that arrived after the page did.
 */
export async function getAnnouncements(companyId: number, signal?: AbortSignal): Promise<Announcement[]> {
    return await apiClient.fetch<Announcement[]>(`companies/${companyId}/announcements`, {signal});
}

/**
 * `keepalive` for a dismissal the user triggered by going somewhere: the browser cancels in-flight
 * requests on navigation, and this one has to outlive the page that started it. Unlike sendBeacon
 * it still carries the antiforgery header.
 */
export async function dismissAnnouncement(
    companyId: number,
    announcementId: string,
    keepalive = false,
): Promise<Announcement[]> {
    return await apiClient.fetch<Announcement[]>(
        `companies/${companyId}/announcements/${announcementId}`,
        {
            method: 'DELETE',
            headers: {[ANTIFORGERY_TOKEN_HEADER]: readAntiforgeryToken()},
            keepalive,
        },
    );
}
